export const FILE_API_HOSTNAME = 'https://cdn.livechat-files.com';
export const FILE_API_PATH = '/api/file/lc/main';
export const FILE_API_PREVIEW_PATH = '/api/file/lc/tmp';
